import { ViewIcon, ViewOffIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Trans, useLingui } from "@lingui/react/macro";
import { TooltipTrigger } from "@radix-ui/react-tooltip";
import * as React from "react";
import { cn } from "~/lib/utils";
import { Button } from "./button";
import { Input } from "./input";
import { Tooltip, TooltipContent, TooltipProvider } from "./tooltip";

export function PasswordInput({
	className,
	type: _type,
	...props
}: React.ComponentProps<typeof Input>) {
	const { t } = useLingui();
	const [showPassword, setShowPassword] = React.useState(false);

	return (
		<div className="relative">
			<Input
				className={cn("pr-10", className)}
				type={showPassword ? "text" : "password"}
				{...props}
			/>
			<div className="absolute top-0 right-0 flex h-full items-center justify-center">
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger asChild>
							<Button
								aria-label={showPassword ? t`Hide password` : t`Show password`}
								className="text-muted-foreground hover:text-foreground"
								onClick={() => setShowPassword(!showPassword)}
								size="icon"
								variant="link"
								type="button"
							>
								<HugeiconsIcon icon={ViewIcon} altIcon={ViewOffIcon} showAlt={showPassword} />
							</Button>
						</TooltipTrigger>
						<TooltipContent>
							{showPassword ? <Trans>Hide password</Trans> : <Trans>Show password</Trans>}
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			</div>
		</div>
	);
}
